/**
 * Built-in presets, responsible for rendering different parts of the editor.
 * @module
 */
export * as classic from './classic'
export * as contextMenu from './context-menu'
export * as minimap from './minimap'
export * as reroute from './reroute'

